module.exports = __webpack_public_path__ + "img/img11.ab3c5f06.svg";